import { CaregiverId } from "../schema/schema";

/**
 * Whether a caregiver's app is connected right now.
 *
 * The Angular side used to answer this from the caregivers dictionary, which a
 * socket wrote into on every `caregiver:online` / `caregiver:offline` event. That
 * made the dictionary a live presence store as well as a lookup cache, and was
 * the main reason it could not be retired. This is the one seam both apps go
 * through instead - see `caregiverAppStatusService` for the Angular half.
 *
 * `getCaregiverOnline` deliberately returns null. Socket deltas on their own
 * cannot answer the question: a page only hears about caregivers whose state
 * *changes* while it is open, so anyone already online before it loaded looks
 * identical to someone offline. Answering it needs an initial snapshot to merge
 * the deltas into, which is still to come.
 *
 * Until then null means "unknown", and callers hide the indicator rather than
 * showing a colour they cannot stand behind.
 */
export type CaregiverAppStatus = {
  /** null while presence is unknown. */
  online: boolean | null;
  /** null while presence is unknown. */
  lastSeen: string | null;
};

const UNKNOWN: CaregiverAppStatus = { online: null, lastSeen: null };

export function getCaregiverAppStatus(_caregiverId: CaregiverId): CaregiverAppStatus {
  return UNKNOWN;
}

/** Convenience for the common case of a single indicator. */
export function getCaregiverOnline(caregiverId: CaregiverId): boolean | null {
  return getCaregiverAppStatus(caregiverId).online;
}
